import React, { useEffect, useRef, useState } from "react";
import "./timer.css";
import Switch from "./switch";
import Hourglass from "../../../../../assets/icons/hourglass";
import { updateTimer } from "../../../../../redux/slices/userActivity";
import { useDispatch, useSelector } from "react-redux";

export default function Timer({ timer }) {
  const [onSwitch, setOnSwitch] = useState(false);

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const [minutesFocusOn, setMinutesFocusOn] = useState(false)
  const [secondsFocusOn, setSecondsFocusOn] = useState(false)

  const minutesRef = useRef(null)
  const secondsRef = useRef(null)
  
  const dispatch = useDispatch();
  const { selectedUserActivity, userActivities } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen, showAnswers } = useSelector((state) => state.preview);

  const resetTimer = () => {
    if (minutesFocusOn === false && secondsFocusOn === false) setOnSwitch(false);
    setMinutes(0);
    setSeconds(0);
  };

  useEffect(() => {
    const setTimer = () => {
      setOnSwitch(true);
      if (timer <= 59) {
        setMinutes(0);
        setSeconds(timer);
      }
      let min = Math.trunc(timer / 60);
      let sec = timer % 60;
      setMinutes(min);
      setSeconds(sec);
    };
    timer === 0 || timer === null ? resetTimer() : setTimer();
  }, [timer, selectedUserActivity, minutesFocusOn, secondsFocusOn]);

  const convertToSeconds = () => {
    const getSeconds = () => (parseInt(seconds) >= 0 ? parseInt(seconds) : 0);
    if (minutes > 0) {
      return parseInt(minutes) * 60 + getSeconds();
    } else {
      return getSeconds();
    }
  };
 
  useEffect(() => {
    if(timer => 1) return
    if (minutes === 0) setMinutes('')
    if (seconds === 0) setSeconds('')
  }, [onSwitch]);

  //focus on elements if tuened on
  useEffect(() => {
    if(minutesFocusOn || secondsFocusOn) return
    if (onSwitch === true) {
      secondsRef.current.focus()
    }
  }, [onSwitch]);

  useEffect(() => {
    if (onSwitch) {
      let timer = convertToSeconds();
      dispatch(updateTimer({ timer }));
    }
  }, [minutes, seconds]);

  const setCurrentSlideTimer = (f) => dispatch(updateTimer({ timer: null }));
  
  const handleMinutesEnter = e => {
    if(e.key === "Enter") secondsRef.current.focus()
  };

  return (
    <div data-html2canvas-ignore="true" className="timer_container" style={{ pointerEvents: previewModalOpen ? "none" : "all" }}>
      <div className="timer">
        <Switch onSwitch={onSwitch} setOnSwitch={setOnSwitch} setCurrentSlideTimer={setCurrentSlideTimer} />
        <Hourglass />
        {
          <div style={!onSwitch ? { display: "none" } : { display: "block" }}>
            <input
              onFocus={e => {setMinutesFocusOn(true);setOnSwitch(true);e.target.select()}}
              onBlur={() => setMinutesFocusOn(false)}
              ref={minutesRef}
              type="number"
              maxLength={2}
              value={minutes}
              placeholder='m'
              onKeyDown={e => handleMinutesEnter(e) }
              onChange={(e) => (e.target.value > 9 ? null : setMinutes(e.target.value))}
              style={{ width: "22px", height: "24px", background: "#fff", borderRadius: "4px", textAlign: "center", marginLeft: "0px" }}
            />
            <span style={{ margin: 0, marginLeft: "1px" }}>:</span>
            <input
              onFocus={e => {setSecondsFocusOn(true);setOnSwitch(true);e.target.select()}}
              onBlur={() => setSecondsFocusOn(false)}
              ref={secondsRef}
              type="number"
              maxLength={2}
              value={seconds}
              placeholder='s'
              onChange={(e) => (e.target.value > 59 ? null : setSeconds(e.target.value))}
              style={{ width: "22px", height: "24px", background: "#fff", marginLeft: "1px", borderRadius: "4px", textAlign: "center", appearance: "none" }}
            />
          </div>
        }
      </div>
    </div>
  );
}
